import { Box, Button, Input, Typography } from '@mui/joy';

import { useState } from 'react';

import toast from 'react-hot-toast';

import { useNavigate } from 'react-router-dom';

import MainLayout from '../../components/Layouts/MainLayout';
import { createTrip } from '../../lib/trip';

export default function NewTrip() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [title, setTitle] = useState('');

  const create = async () => {
    if (!title) return;
    setSaving(true);
    const resp = await toast.promise(createTrip({ title }), {
      loading: 'Creating trip...',
      success: 'Trip created successfully',
      error: 'Error while creating trip'
    });

    setTimeout(() => {
      setSaving(false);
      navigate(`/trip/${resp._id}/options`);
    }, 500);
  };

  return (
    <MainLayout title="New Trip">
      <Box
        sx={{
          maxWidth: '400px',
          margin: 'auto'
        }}>
        <Typography level="title-md">Please, provide a title for the trip</Typography>
        <Input
          placeholder="Title"
          sx={{ marginTop: '5px' }}
          onChange={(e) => setTitle(e.target.value)}
        />
        <Button
          sx={{ width: '100%', marginTop: '5px' }}
          disabled={saving || !title.length}
          onClick={create}>
          Continue
        </Button>
      </Box>
    </MainLayout>
  );
}
